import { html, View } from 'rune-ts';
import quickMenuClass from './QuickMenu.module.scss';
import { dataStr } from '../../../../shared/util/dataStr';
import { font } from '@services/MarppleShop/shared/typography';

export interface QuickMenuData {
  title_pc: string;
  title_mo: string;
  image: string;
  navigate: object;
  href: string;
  target: '_self' | '_blank';
  is_hidden?: boolean;
  mp4_src?: string;
}

export type QuickMenuViewOptions = {
  size: 'medium' | 'small';
  use_scroll_snap?: boolean;
};

class QuickMenuView extends View<QuickMenuData> {
  constructor(
    data: QuickMenuData,
    public option: QuickMenuViewOptions,
  ) {
    super(data, option);
  }

  public static readonly SizeOptions = {
    medium: quickMenuClass.medium,
    small: quickMenuClass.small,
  };

  private get size() {
    return QuickMenuView.SizeOptions[this.option.size];
  }

  private get fontSize(): string {
    switch (this.option.size) {
      case 'medium':
        return font('16_medium');
      case 'small':
        return font('12_medium');
    }
  }

  private get scrollSnap(): string {
    return this.option.use_scroll_snap ? quickMenuClass.scroll_snap : '';
  }

  protected override template() {
    const { href, target, image, title_mo, title_pc, navigate, mp4_src } = this.data;

    return html`
      <a
        class="${quickMenuClass.quick_menu} ${this.scrollSnap}"
        ${navigate ? html`data-post-message="${dataStr(navigate)}"` : ''}
        href="${html.preventEscape(href)}"
        target="${target}"
      >
        <div class="${quickMenuClass.image_container} ${this.size}">
          ${mp4_src
            ? html`<video class=${quickMenuClass.image} autoplay loop muted playsinline poster="${image}">
                <source src="${mp4_src}" type="video/mp4" />
                <img src="${image}" alt="Your browser does not support video." />
              </video>`
            : html`<img class="${quickMenuClass.image}" src="${image}" alt="" />`}
        </div>
        <span class="${quickMenuClass.title} ${this.fontSize} ${this.size}">
          ${this.option.size === 'small' ? title_mo : title_pc}
        </span>
      </a>
    `;
  }
}

export type QuickMenuListViewOptions = {
  size: 'medium' | 'small';
  use_scroll_snap?: boolean;
};

export class QuickMenuListView extends View<QuickMenuData[]> {
  constructor(
    data: QuickMenuData[],
    public option: QuickMenuListViewOptions,
  ) {
    super(data, option);
  }

  protected override template() {
    return html`
      <div class="${quickMenuClass.quick_menu_list} ${this.scrollSnap} ${this.size}">
        ${this.data.filter((menu) => !menu.is_hidden).map((menu) => new QuickMenuView(menu, this.option))}
      </div>
    `;
  }

  private get scrollSnap() {
    return this.option.use_scroll_snap ? quickMenuClass.scroll_snap : '';
  }

  public static readonly SizeOptions = {
    medium: quickMenuClass.medium,
    small: quickMenuClass.small,
  };

  private get size() {
    return QuickMenuListView.SizeOptions[this.option.size];
  }
}
